import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SelectedCustomerService } from 'gung-standard';
import { first, switchMap } from 'rxjs';
import { TyloPriceConfigService } from '../../services/tylo-price-config.service';

export interface TyloPriceMarkup {
  customerId: string,
  markupPercentage: number
}

@Component({
    selector: 'tylo-tylo-customer-b2c-price-markup-modal',
    templateUrl: './tylo-customer-b2c-price-markup-modal.component.html',
    styleUrl: './tylo-customer-b2c-price-markup-modal.component.css',
    standalone: false
})
export class TyloCustomerB2cPriceMarkupModalComponent implements OnInit {
  customerPriceMarkup: TyloPriceMarkup;

  constructor(
    protected activeModal: NgbActiveModal,
    protected selectedCustomerService: SelectedCustomerService,
    protected http: HttpClient,
    protected priceConfig: TyloPriceConfigService
  ) {}

  ngOnInit(): void {
    this.selectedCustomerService.getSelectedCustomer().pipe(
      first(),
      switchMap(selectedCustomer => this.priceConfig.getB2CPriceMarkup(selectedCustomer.id))
    ).subscribe(customerPriceMarkup => {
      this.customerPriceMarkup = customerPriceMarkup;
    });
  }

  save(): void {
    this.priceConfig.updateB2CPriceMarkup(this.customerPriceMarkup).pipe(first()).subscribe(() => {this.activeModal.close()});
  }

  close(): void {
    this.activeModal.dismiss();
  }
}
